import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const reduceMotionQuery = typeof window !== 'undefined'
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null

const revealGroups = [
    {
        selector: '.animation-crad',
        from: { opacity: 0, scale: 0.94, y: 24 },
        to: { opacity: 1, scale: 1, y: 0, duration: 0.62, ease: 'power2.out' },
        stagger: 0.08,
        batchMax: 4
    },
    {
        selector: '.animation-title',
        from: { opacity: 0, y: 18, scale: 0.98 },
        to: { opacity: 1, x: 0, y: 0, scale: 1, duration: 0.68, ease: 'power3.out' },
        stagger: 0.06,
        batchMax: 3
    },
    {
        selector: '.animation-text',
        from: { opacity: 0, y: 28 },
        to: { opacity: 1, y: 0, duration: 0.58, ease: 'power2.out' },
        stagger: 0.05,
        batchMax: 6
    }
]

function prefersReducedMotion() {
    return reduceMotionQuery && reduceMotionQuery.matches
}

export function createScrollReveal(root) {
    if (!root) {
        return () => {}
    }

    const triggers = []
    const animatedElements = []

    revealGroups.forEach((group) => {
        const elements = gsap.utils.toArray(root.querySelectorAll(group.selector))

        if (elements.length === 0) {
            return
        }

        animatedElements.push(...elements)

        if (prefersReducedMotion()) {
            gsap.set(elements, { opacity: 1, x: 0, y: 0, scale: 1, clearProps: 'transform,willChange' })
            return
        }

        gsap.set(elements, {
            ...group.from,
            willChange: 'transform, opacity'
        })

        const batchTriggers = ScrollTrigger.batch(elements, {
            start: 'top 88%',
            once: true,
            interval: 0.12,
            batchMax: group.batchMax,
            onEnter: (batch) => {
                gsap.to(batch, {
                    ...group.to,
                    stagger: group.stagger,
                    overwrite: true,
                    clearProps: 'transform,willChange'
                })
            }
        })

        triggers.push(...batchTriggers)
    })

    requestAnimationFrame(() => ScrollTrigger.refresh())

    return () => {
        triggers.forEach((trigger) => trigger.kill())
        gsap.killTweensOf(animatedElements)
        gsap.set(animatedElements, { clearProps: 'transform,willChange' })
    }
}

export function refreshScrollReveal() {
    requestAnimationFrame(() => ScrollTrigger.refresh())
}
